import {Select, Space} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {FormField, FormFieldError} from "../../../../../design-system/form-field";
import {StoreServiceDeliveryTimeFrameUnitFormFieldProps} from "../types";
import {StoreServiceDeliveryTimeFrameFormFields} from "../types";

export const DeliveryTimeFrameUnitOptions = [
  {
    label: "Days",
    value: "days",
  },
  {
    label: "Weeks",
    value: "weeks",
  },
  {
    label: "Months",
    value: "months",
  },
];

export function ServiceDeliveryTimeFrameUnitFormField({
  id,
  label,
  placeholder,
}: StoreServiceDeliveryTimeFrameUnitFormFieldProps) {
  const {control} = useFormContext<StoreServiceDeliveryTimeFrameFormFields>();

  return (
    <div>
      <FormField
        id={id}
        label={label}
        renderInput={(id) => (
          <Controller
            control={control}
            name="deliveryTimeFrameUnit"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <Space direction="vertical" size={16} style={{display: "flex"}}>
                <Select
                  id={id}
                  size="large"
                  status={error?.message ? "error" : undefined}
                  style={{width: "100%"}}
                  onChange={onChange}
                  value={value}
                  ref={ref}
                  onBlur={onBlur}
                  options={DeliveryTimeFrameUnitOptions}
                  placeholder={placeholder}
                />
                <FormFieldError errorMessage={error?.message} />
              </Space>
            )}
          />
        )}
      />
    </div>
  );
}
